import { useState, useReducer } from 'react';
import AssetInput from '../../../components/AssetInput';
import { Tokens, Validators } from '../../../config/constants';
import { formatUSD } from '../../../helpers';
import { preventOverflow } from '../../../web3/utils';
import ExchangeSwapContent from './ExchangeSwapContent';
import OrderExpiryDropdown from '../../../components/OrderExpiryDropdown';

const initialState = {
    limitPrice: '',
    triggerPrice: '',
};

const ExchangeTakeProfitLimit: React.FC = () => {
    const [amount, setAmount] = useState(initialState);
    const [withExpiryDate, toggleWithExpiryDate] = useReducer((prev) => !prev, false);
    const [expiryDate, setExpiryDate] = useState<Date | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setAmount((prev) => ({ ...prev, [name]: preventOverflow(value) }));
    };

    const validators: Validators[] = [];

    const handleConfirm = async () => {
        return '';
    };

    return (
        <ExchangeSwapContent handleConfirm={handleConfirm} validators={validators}>
            <AssetInput
                variant='secondary'
                label='Limit Price'
                sideLabel={<>Mark Price: {formatUSD(31323 || 0)}</>}
                asset={Tokens.USDC}
                name='limitPrice'
                value={amount.limitPrice}
                onChange={handleChange}
            />
            <AssetInput
                variant='secondary'
                label='Trigger Price'
                sideLabel={<>Mark Price: {formatUSD(31323 || 0)}</>}
                asset={Tokens.USDC}
                name='triggerPrice'
                value={amount.triggerPrice}
                onChange={handleChange}
            />
            <OrderExpiryDropdown
                value={expiryDate}
                orderExpiryChecked={withExpiryDate}
                onChange={setExpiryDate}
                toggleOrderExpiry={toggleWithExpiryDate}
            />
        </ExchangeSwapContent>
    );
};

export default ExchangeTakeProfitLimit;
